import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useJourney } from "@/v2/V2Shell";

export default function V2Projects() {
  const { reload } = useJourney();
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/v2/projects").then(({ data }) => setP(data)).catch(() => {}); }, []);
  const act = async (key, action) => {
    try { const { data } = await api.post(`/v2/projects/${key}/${action}`); setP(data); reload(); toast.success(action === "start" ? "Project started. It shapes your days from tomorrow." : action === "complete" ? "Project complete. Added to your wins." : "Project paused"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!p) return null;
  const active = p.mine.filter((m) => m.status === "active");
  const activeKeys = active.map((m) => m.key);
  const available = Object.entries(p.library).filter(([k]) => !activeKeys.includes(k));
  const done = p.mine.filter((m) => m.status === "completed");
  return (
    <div className="space-y-6" data-testid="v2-projects">
      <p className="text-stone-600 text-sm">What you're building: up to 2 projects at a time, so your days stay focused. Each one shapes your daily steps.</p>
      <div className="space-y-3">
        {active.map((m) => (
          <div key={m.id} className="card p-5" data-testid={`project-active-${m.key}`}>
            <div className="flex items-center justify-between"><span className="eyebrow">Week {m.week} of {m.weeks}</span>
              {m.key === "weight_reset" && <Link to="/journey/plan/weight" data-testid="project-weight-open" className="min-h-11 inline-flex items-center px-1 text-xs underline">Trend & review</Link>}</div>
            <h3 className="font-display text-xl mt-1">{m.title}</h3>
            <p className="text-sm text-stone-600 mt-0.5">This week: {m.milestone}</p>
            <div className="h-1.5 rounded-full bg-[#EFECE6] mt-3"><div className="h-full rounded-full bg-stone-800" style={{ width: `${(m.week / m.weeks) * 100}%` }} /></div>
            <div className="flex gap-4 mt-3 text-xs">
              <button onClick={() => act(m.key, "complete")} data-testid={`project-complete-${m.key}`} className="min-h-11 inline-flex items-center px-1 underline font-semibold">Mark complete</button>
              <button onClick={() => act(m.key, "stop")} data-testid={`project-stop-${m.key}`} className="min-h-11 inline-flex items-center px-1 underline text-stone-500">Pause project</button>
            </div>
          </div>
        ))}
        {!active.length && <p className="text-sm text-stone-500">No active projects yet. Pick one below.</p>}
      </div>
      <div>
        <div className="eyebrow mb-3">Library</div>
        <div className="grid sm:grid-cols-2 gap-3">
          {available.map(([k, pr]) => (
            <div key={k} className="card p-5 flex flex-col" data-testid={`project-lib-${k}`}>
              <span className="eyebrow">{pr.weeks} weeks · {pr.phase_name}</span>
              <h3 className="font-display text-lg mt-1">{pr.title}</h3>
              <p className="text-sm text-stone-600 mt-1 flex-1">{pr.summary}</p>
              {k === "weight_reset" && !p.weight_setup ? (
                <Link to="/journey/plan/weight" data-testid="project-weight-setup" className="btn-ink mt-4 h-11 rounded-full text-sm font-semibold grid place-items-center">Set up (opt-in)</Link>
              ) : (
                <button onClick={() => act(k, "start")} disabled={active.length >= 2} data-testid={`project-start-${k}`} className="btn-ink mt-4 h-11 rounded-full text-sm font-semibold disabled:opacity-40">{active.length >= 2 ? "2 projects active" : "Start"}</button>
              )}
            </div>
          ))}
        </div>
      </div>
      {done.length > 0 && <div><div className="eyebrow mb-2">Completed</div>{done.map((m) => <p key={m.id} className="text-sm" data-testid={`project-done-${m.key}`}>{m.title} · finished {m.ended_at}</p>)}</div>}
    </div>
  );
}
